import React from 'react';

const InfoBubble = (props) => {
  const { onClick, dark, onMouseEnter, ref } = props;

  return (
    <button
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      onMouseEnter={() => {
        if (onMouseEnter) {
          onMouseEnter();
        }
      }}
      ref={ref}
      className={`infoButton ${dark ? 'infoButton--dark' : ''}`}
    >
      <span>i</span>
      <span className="sr-only">More info</span>
    </button>
  );
};

export default InfoBubble;
